import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=35033e16&scoped=true&"
import script from "./PriceInput.vue?vue&type=script&lang=ts&"
export * from "./PriceInput.vue?vue&type=script&lang=ts&"
import style0 from "./PriceInput.vue?vue&type=style&index=0&id=35033e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35033e16",
  null
  
)

export default component.exports